import { Link } from "wouter";
import Icon from "@/components/mnf/Icon";
import Logo from "@/components/mnf/Logo";
import { GlassCard, Btn, PillTag } from "@/components/mnf/UI";

const verses = [
  { ref: "Isaiah 58:11", text: "You will be like a well-watered garden." },
  { ref: "Psalm 139:14", text: "Fearfully and wonderfully made." },
  { ref: "Proverbs 31:25", text: "Clothed with strength and dignity." },
];

export default function Welcome() {
  return (
    <div className="relative h-full overflow-hidden">
      {/* Hero gradient */}
      <div
        className="relative pt-12 pb-8 px-6 text-center overflow-hidden"
        style={{
          background:
            "radial-gradient(120% 80% at 50% 0%, #2C6248 0%, #1E4A35 50%, #163828 100%)",
          color: "#F5F0E8",
          borderRadius: "0 0 32px 32px",
          minHeight: 360,
        }}
      >
        <div className="mnf-orb" />
        <div
          className="mnf-orb"
          style={{
            top: "auto", bottom: -110, left: -40, right: "auto",
            background: "rgba(168,212,184,0.20)", width: 220, height: 220,
          }}
        />

        <div className="relative flex flex-col items-center">
          <div className="mnf-float" style={{ color: "#F5F0E8" }}>
            <Logo size={56} />
          </div>
          <p className="mnf-eyebrow mt-3" style={{ color: "rgba(229,185,151,0.95)" }}>
            Faith · Fitness · Sisterhood
          </p>
          <h1 className="mnf-serif mt-2" style={{ fontSize: 38, fontWeight: 500, lineHeight: 1.05, color: "#F5F0E8" }}>
            Move · Nourish<br />
            <span className="italic" style={{ color: "rgba(229,185,151,0.95)" }}>Flourish</span>
          </h1>
          <p className="mnf-body mt-3 italic" style={{ fontSize: 13.5, lineHeight: 1.55, color: "rgba(245,240,232,0.85)", maxWidth: 280 }}>
            A garden for body, soul, and sisterhood.
            Track meals, plan family menus, log workouts, and grow alongside sisters in faith.
          </p>
        </div>
      </div>

      {/* Verse rotator */}
      <div className="px-5 mt-5">
        <GlassCard padding={16}>
          <p className="mnf-eyebrow">Today's nourishment</p>
          <p className="mnf-serif italic mt-1" style={{ fontSize: 16, lineHeight: 1.4, color: "var(--mnf-fd)" }}>
            "{verses[0].text}"
          </p>
          <p className="mnf-body uppercase mt-2 text-[11px]" style={{ color: "var(--mnf-t)", letterSpacing: "0.18em", fontWeight: 700 }}>
            {verses[0].ref}
          </p>
        </GlassCard>
      </div>

      {/* Tour the app */}
      <div className="px-5 mt-4">
        <p className="mnf-eyebrow">Where you'll walk</p>
        <h2 className="mnf-serif mt-1" style={{ fontSize: 20, fontWeight: 500, color: "var(--mnf-fd)" }}>
          Five sanctuaries, one journey
        </h2>

        <div className="grid grid-cols-2 gap-2.5 mt-3 pb-4">
          {[
            { href: "/garden",   l: "Garden",   d: "Food log + meal plan",      icon: "yard",          tone: "rgba(30,74,53,0.06)",     fg: "var(--mnf-f)" },
            { href: "/move",     l: "Move",     d: "Strength & grace workouts", icon: "fitness_center", tone: "rgba(192,120,74,0.10)",  fg: "var(--mnf-t)" },
            { href: "/nourish",  l: "Nourish",  d: "Tomorrow's harvest prep",   icon: "restaurant",     tone: "var(--mnf-gold2)",        fg: "var(--mnf-gold)" },
            { href: "/flourish", l: "Flourish", d: "Sisterhood prayer wall",    icon: "menu_book",      tone: "var(--mnf-purpleL)",     fg: "var(--mnf-purple)" },
            { href: "/sisters",  l: "Sisters",  d: "Legacy mentorship feed",    icon: "diversity_3",    tone: "rgba(168,212,184,0.30)", fg: "var(--mnf-f)" },
            { href: "/share",    l: "Share Grace", d: "Verse share card",       icon: "ios_share",      tone: "rgba(30,74,53,0.06)",    fg: "var(--mnf-f)" },
          ].map((t) => (
            <Link
              key={t.href}
              href={t.href}
              className="block no-underline mnf-glass hover-elevate"
              style={{ padding: 14, borderRadius: 18 }}
            >
              <div
                className="flex items-center justify-center mb-2.5"
                style={{ width: 36, height: 36, borderRadius: 12, background: t.tone, color: t.fg }}
              >
                <Icon name={t.icon} size={20} filled />
              </div>
              <p className="mnf-serif" style={{ fontSize: 15, fontWeight: 500, color: "var(--mnf-fd)" }}>
                {t.l}
              </p>
              <p className="text-[11px] mnf-body" style={{ color: "var(--mnf-tg)" }}>
                {t.d}
              </p>
            </Link>
          ))}
        </div>

        <Link href="/garden" className="block no-underline">
          <Btn variant="primary" block size="lg">
            <span style={{ marginRight: 4 }}>🌱</span> Enter the garden
          </Btn>
        </Link>

        <p className="text-center text-[11px] mnf-body mt-3 italic" style={{ color: "var(--mnf-tg)" }}>
          Design preview · a faith-based fitness sanctuary for Christian women
        </p>
      </div>
    </div>
  );
}
